import axios from "axios";
import { baseURL } from "../globals/constants";
import { showErrorToast } from "../utils/Toast";

export interface SettingField {
  key: string;
  label: string;
  type?: "text" | "number" | "boolean" | "url" | "email";
  secret?: boolean;
  required?: boolean;
  help?: string;
  default?: string | number | boolean;
}
export interface SettingArea {
  key: string;
  label: string;
  description: string;
  defaultProvider: string;
  public: boolean;
  providers: { key: string; label: string; fields: SettingField[] }[];
}
export interface SettingValue {
  area: string;
  provider: string;
  config: Record<string, string | number | boolean>;
  secrets: Record<string, boolean>;
  saved: boolean;
}
export type Values = Record<string, string | number | boolean>;

const headers = () => ({ headers: { Accept: "application/json", Authorization: `Bearer ${localStorage.getItem("access_token")}` } });
const url = `${baseURL}/v1/platform-settings`;

export const getSettingDefinitions = async (): Promise<SettingArea[]> => (await axios.get(`${url}/definitions`, headers())).data;
export const getSettings = async (): Promise<SettingValue[]> => (await axios.get(url, headers())).data;

export const saveSetting = async (area: string, provider: string, config: Values, secrets: Values, isMobile: boolean) => {
  try {
    return (await axios.put(`${url}/${area}`, { provider, config, secrets }, headers())).data as SettingValue;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not save", isMobile);
    return null;
  }
};

export const resetSetting = async (area: string, isMobile: boolean) => {
  try {
    return (await axios.delete(`${url}/${area}`, headers())).data as SettingValue;
  } catch (error: any) {
    showErrorToast(error?.response?.data?.message || "Could not reset", isMobile);
    return null;
  }
};

export const testSetting = async (area: string, provider: string, config: Values, secrets: Values, to: string) => {
  try {
    return (await axios.post(`${url}/${area}/test`, { provider, config, secrets, to }, headers())).data as { ok: boolean; message: string };
  } catch (error: any) {
    return { ok: false, message: error?.response?.data?.message || "Test failed" };
  }
};

export interface StorageCheck {
  ok: boolean;
  message?: string;
  total?: number;
  found?: number;
  missing?: { key: string; breefName: string; deleted: boolean }[];
  missingCount?: number;
  external?: number;
  notConverted?: number;
  publiclyReadable?: boolean | null;
  publicStatus?: string | null;
}

/** "Tjek lager": do all breef videos exist in the storage in the form (not saved)? */
export const checkStorage = async (provider: string, config: Values, secrets: Values): Promise<StorageCheck> => {
  try {
    return (await axios.post(`${url}/storage/check`, { provider, config, secrets }, headers())).data as StorageCheck;
  } catch (error: any) {
    return { ok: false, message: error?.response?.data?.message || "Check failed" };
  }
};

